import React from 'react';
import SEO from '../../../components/SEO/SEO';

import { Link } from 'react-router-dom';
import './Automotive.css';

const Automotive = () => {
    return (
        <div className="industry-page">
            <SEO 
                title="Automotive Services | Digi Network" 
                description="Learn more about our Automotive services to grow your business online with Digi Network." 
                canonical="/industries/automotive/automotive" 
            />

            <section className="industry-hero">
                <div className="industry-hero-bg"></div>
                <div className="container">
                    <div className="industry-hero-content">
                        <div className="label">Automotive Industry</div>
                        <h1>Digital Marketing for Automotive</h1>
                        <p>Drive car sales, service bookings, and grow your automotive business with targeted digital marketing strategies for dealerships and auto services. We understand the unique challenges automotive businesses face in today's competitive market.</p>
                        <div className="industry-hero-cta">
                            <Link to="/contact" className="btn btn-primary">
                                Get Started
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </Link>
                            <Link to="/case-studies" className="btn btn-outline">View Results</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="hero-image-section">
                <div className="container">
                    <div className="image-placeholder-large">
                        <p>📷 Add Automotive Hero Image (1200x500px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-services">
                <div className="container">
                    <h2>Automotive Marketing Services</h2>
                    <p className="section-intro">Comprehensive marketing solutions tailored for automotive businesses</p>
                    <div className="services-grid">
                        <div className="service-card">
                            <h3>Automotive SEO</h3>
                            <p>Rank for car searches, local dealership keywords, and drive qualified traffic to your inventory. Our automotive SEO strategies help dealerships dominate local search results and attract qualified buyers.</p>
                            <ul>
                                <li>Local SEO for dealerships</li>
                                <li>Vehicle inventory optimization</li>
                                <li>Google My Business for auto</li>
                                <li>Service & parts optimization</li>
                                <li>Automotive directory listings</li>
                                <li>Review management</li>
                            </ul>
                            <Link to="/industries/automotive/seo" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Automotive Paid Ads</h3>
                            <p>Drive car sales and service bookings with high-converting advertising campaigns. Our targeted ad campaigns reach people actively searching for vehicles and automotive services.</p>
                            <ul>
                                <li>Google Ads for car sales</li>
                                <li>Facebook & Instagram ads</li>
                                <li>Inventory promotion campaigns</li>
                                <li>Service special offers</li>
                                <li>Retargeting strategies</li>
                                <li>Conversion tracking & optimization</li>
                            </ul>
                            <Link to="/industries/automotive/paid-ads" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Automotive Website Development</h3>
                            <p>Professional dealership websites with inventory listings, service booking, and finance applications. Our automotive websites are designed to showcase your inventory and make it easy for customers to buy.</p>
                            <ul>
                                <li>Dealership website design</li>
                                <li>Vehicle inventory management</li>
                                <li>Online service booking</li>
                                <li>Finance application forms</li>
                                <li>Mobile-responsive design</li>
                                <li>Trade-in calculators</li>
                            </ul>
                            <Link to="/industries/automotive/web-development" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Automotive Email Marketing</h3>
                            <p>Nurture leads, promote inventory, and drive repeat service visits with automated campaigns. Build lasting relationships with customers through strategic email communication that provides value.</p>
                            <ul>
                                <li>Lead nurturing campaigns</li>
                                <li>Inventory promotion emails</li>
                                <li>Service reminder campaigns</li>
                                <li>Customer retention programs</li>
                                <li>Seasonal promotions</li>
                                <li>Referral programs</li>
                            </ul>
                            <Link to="/industries/automotive/email-marketing" className="service-link">Learn More →</Link>
                        </div>

                        <div className="service-card">
                            <h3>Automotive CRM & Automation</h3>
                            <p>Manage leads, automate follow-ups, and track sales pipeline with GoHighLevel for automotive. Streamline your sales and service operations with automated workflows that scale.</p>
                            <ul>
                                <li>Lead management system</li>
                                <li>Automated follow-up sequences</li>
                                <li>Sales pipeline tracking</li>
                                <li>Customer communication automation</li>
                                <li>Service appointment reminders</li>
                                <li>Customer satisfaction tracking</li>
                            </ul>
                            <Link to="/industries/automotive/all-in-one" className="service-link">Learn More →</Link>
                        </div>
                    </div>
                </div>
            </section>

            <section className="process-section">
                <div className="container">
                    <h2 className="process-item-title">Our Automotive Marketing Process</h2>
                    <p className="section-intro">A proven methodology designed specifically for automotive businesses</p>
                    <div className="process-grid">
                        <div className="process-item">
                            <div className="process-number">1</div>
                            <h3>Market Analysis</h3>
                            <p>We analyze your local automotive market, competition, and target audience to understand what drives car buying decisions. Our team conducts comprehensive research to identify the best marketing opportunities.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">2</div>
                            <h3>Sales-Focused Strategy</h3>
                            <p>We develop a customized marketing strategy that focuses on driving car sales and service bookings. Every tactic is designed to convert browsers into buyers and service customers.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">3</div>
                            <h3>Multi-Channel Implementation</h3>
                            <p>We implement the marketing strategy across all channels, from SEO to paid ads to email. Our team handles everything from inventory promotion to service booking optimization.</p>
                        </div>
                        <div className="process-item">
                            <div className="process-number">4</div>
                            <h3>Conversion & Growth</h3>
                            <p>We continuously monitor performance, analyze customer data, and optimize campaigns for better results. Regular reporting keeps you informed of your sales and service booking metrics.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Automotive Process Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="why-choose">
                <div className="container">
                    <h2>Why Automotive Businesses Choose Digi Network</h2>
                    <p className="why-intro">Trusted by automotive professionals across the UAE and internationally</p>
                    <div className="why-grid">
                        <div className="why-item">
                            <div className="why-number">01</div>
                            <h3>Sales-Focused</h3>
                            <p>Every strategy is designed to drive car sales and service bookings, not just website traffic. We understand that automotive success is measured in sales and service revenue.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">02</div>
                            <h3>Automotive Expertise</h3>
                            <p>We understand the automotive market and create campaigns that convert browsers into buyers. Our team has extensive experience working with dealerships and auto service centers.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">03</div>
                            <h3>Lead Generation</h3>
                            <p>We focus on generating qualified leads who are ready to buy or schedule service. Our strategies target people actively looking for vehicles and automotive services.</p>
                        </div>
                        <div className="why-item">
                            <div className="why-number">04</div>
                            <h3>Proven Results</h3>
                            <p>We've helped automotive businesses increase sales by 320%+ through targeted marketing. Our data-driven approach delivers measurable results that directly impact your bottom line.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="benefits-section">
                <div className="container">
                    <h2>Key Benefits for Automotive Businesses</h2>
                    <p className="section-intro">How our marketing services help you grow your automotive business</p>
                    <div className="benefits-grid">
                        <div className="benefit-item">
                            <h3>More Car Sales</h3>
                            <p>Generate more qualified leads and close more car sales through targeted marketing campaigns. Our strategies focus on converting interested prospects into buyers.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better Online Visibility</h3>
                            <p>Dominate local search results for car sales and automotive services. When potential customers search for vehicles, they'll find your dealership first.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Increased Service Bookings</h3>
                            <p>Drive more service bookings through targeted campaigns and automated reminders. Keep your service bays full and maximize your service revenue.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Better Customer Relationships</h3>
                            <p>Automate follow-ups and nurture relationships with automated email campaigns. Keep in touch with past customers and turn them into repeat buyers.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Higher Revenue</h3>
                            <p>Increase revenue through more sales, higher service bookings, and better retention. Our strategies help you maximize every aspect of your automotive business.</p>
                        </div>
                        <div className="benefit-item">
                            <h3>Competitive Advantage</h3>
                            <p>Stay ahead of competitors with cutting-edge marketing strategies and technology. Many automotive businesses still rely on outdated marketing methods.</p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="image-section">
                <div className="container">
                    <div className="image-placeholder-medium">
                        <p>📷 Add Automotive Benefits Image (1200x400px)</p>
                    </div>
                </div>
            </section>

            <section className="industry-cta">
                <div className="container">
                    <h2>Ready to Drive More Car Sales?</h2>
                    <p>Let's discuss how we can help you attract more customers and grow your automotive business.</p>
                    <Link to="/contact" className="btn btn-primary">
                        Book a Free Consultation
                        <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4766 12.1562L14.8516 21.7812C14.5234 22.1094 13.9219 22.1094 13.5938 21.7812C13.2656 21.4531 13.2656 20.8516 13.5938 20.5234L21.7422 12.375H1.125C0.632812 12.375 0.25 11.9922 0.25 11.5C0.25 11.0625 0.632812 10.625 1.125 10.625H21.7422L13.5938 2.53125C13.2656 2.20312 13.2656 1.60156 13.5938 1.27344C13.9219 0.945312 14.5234 0.945312 14.8516 1.27344L24.4766 10.8984C24.8047 11.2266 24.8047 11.8281 24.4766 12.1562Z" fill="white"/>
                        </svg>
                    </Link>
                </div>
            </section>
        </div>
    );
};

export default Automotive;
